import { useEffect, useState } from 'react';
import {
  listApprovedOfficers,
  type PublicOfficer,
} from '../web3/officerDirectory';

export function useApprovedOfficers(country: string, chainId: number | null) {
  const [officers, setOfficers] = useState<PublicOfficer[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!country || country === 'Other' || !chainId) {
      setOfficers([]);
      return;
    }
    let cancelled = false;
    setLoading(true);
    listApprovedOfficers(chainId, country)
      .then((rows) => {
        if (!cancelled) setOfficers(rows);
      })
      .catch(() => {
        if (!cancelled) setOfficers([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [country, chainId]);

  return { officers, loading };
}
